<div class="fixed inset-0 z-[100] flex items-center justify-center bg-black/50">
    <div class="bg-white rounded-xl w-[528px] p-[30px] relative">

        <!-- Close -->
        <button class="w-9 h-9 flex items-center justify-center rounded-full absolute -right-4 -top-4 bg-light-black-100
             hover:bg-black hover:text-white duration-200 ease-in-out cursor-pointer" (click)="closeModal()">
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M12.0404 0.708496L0.707796 12.0411M12.0396 12.0418L0.707031 0.709299" stroke="currentColor"
                    stroke-opacity="0.8" stroke-width="1.41667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </button>

        <!-- STEP 1 -->
        <ng-container *ngIf="step === 1">
            <div class="flex flex-col gap-5 sm:gap-6 md:gap-8 lg:gap-10 text-center">
                <span class="mx-auto w-[70px] h-[70px] block">
                    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                        <path
                            d="M70 34.0178C70 37.2772 67.3604 39.9167 64.101 39.9167H43.75L35 22.2199L44.4427 5.86466C46.076 3.04279 49.6781 2.08029 52.5 3.70633C55.3219 5.33966 56.2844 8.94174 54.6583 11.7636L45.2156 28.1188H64.101C67.3604 28.1188 70 30.7584 70 34.0178Z"
                            fill="#1A73E8" />
                        <path
                            d="M52.5111 64.3302C49.6893 65.9563 46.0872 64.9937 44.4539 62.1719L35.0111 45.8167L25.5684 62.1719C23.9351 64.9937 20.333 65.9563 17.5111 64.3302C14.6893 62.6969 13.7268 59.0948 15.3528 56.2729L24.7955 39.9177L35.0111 39.5312L45.2268 39.9177L54.6695 56.2729C56.2955 59.0948 55.333 62.6969 52.5111 64.3302Z"
                            fill="#EA4335" />
                        <path
                            d="M35.0111 22.2199L32.3497 29.4532L24.7955 28.1188L15.3528 11.7636C13.7268 8.94174 14.6893 5.33966 17.5111 3.70633C20.333 2.08029 23.9351 3.04279 25.5684 5.86466L35.0111 22.2199Z"
                            fill="#FBBC04" />
                        <path
                            d="M33.476 28.1191L26.6292 39.9171H5.89896C2.63958 39.9171 0 37.2775 0 34.0181C0 30.7587 2.63958 28.1191 5.89896 28.1191H33.476Z"
                            fill="#34A853" />
                        <path d="M45.2203 39.9176H24.7891L35.0047 22.2207L45.2203 39.9176Z" fill="#185DB7" />
                    </svg>
                </span>

                <div>
                    <h3 class="text-lg md:text-xl lg:text-2xl text-black font-bold mb-2">
                        You’ll need an Authenticator app
                    </h3>
                    <p class="text-base text-secondary-text-black">
                        To enable multi-factor authentication, you will need to use an
                        authenticator app like
                        <a class="font-semibold underline text-black">
                            Google Authenticator
                        </a>.
                    </p>
                </div>

                <button
                    class="text-sm font-syne bg-black text-white py-3.5 rounded-xl font-semibold hover:text-black hover:bg-secondary-button-black duration-200 ease-in-out cursor-pointer"
                    (click)="initiateMFA()">
                    Next
                </button>
            </div>
        </ng-container>

        <!-- STEP 2 -->
        <ng-container *ngIf="step === 2">
            <div class="flex flex-col gap-5 sm:gap-6 md:gap-8 lg:gap-10 text-center">
                <img src="{{ mfaResp?.qr_code_base64 }}" alt="QR Code" class="mx-auto w-[180px] h-[180px]" />
                <div>
                    <h3 class="text-lg md:text-xl lg:text-2xl text-black font-bold mb-2">
                        Scan this QR code
                    </h3>

                    <p class="text-base font-medium text-secondary-text-black">
                        Open your authenticator app and scan this QR code or enter your setup key
                    </p>
                </div>

                <div class="flex flex-col gap-5">
                    <div class=" flex justify-center gap-2">
                        <p class="text-base text-secondary-text-black font-medium">{{ mfaResp?.manual_key }}</p>
                        <span class="cursor-pointer" (click)="copyRecoveryCode(mfaResp?.manual_key)">
                            <ng-container *ngIf="!isCopied; else copiedIcon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                    fill="none">
                                    <path
                                        d="M7.5 12.5C7.5 10.143 7.5 8.9645 8.23223 8.23223C8.9645 7.5 10.143 7.5 12.5 7.5H13.3333C15.6903 7.5 16.8688 7.5 17.6011 8.23223C18.3333 8.9645 18.3333 10.143 18.3333 12.5V13.3333C18.3333 15.6903 18.3333 16.8688 17.6011 17.6011C16.8688 18.3333 15.6903 18.3333 13.3333 18.3333H12.5C10.143 18.3333 8.9645 18.3333 8.23223 17.6011C7.5 16.8688 7.5 15.6903 7.5 13.3333V12.5Z"
                                        stroke="black" stroke-opacity="0.5" stroke-width="1.25" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M14.164 7.49935C14.162 5.03511 14.1247 3.75869 13.4074 2.88471C13.2689 2.71592 13.1141 2.56117 12.9454 2.42265C12.0234 1.66602 10.6536 1.66602 7.91406 1.66602C5.1745 1.66602 3.80471 1.66602 2.88275 2.42265C2.71397 2.56116 2.55921 2.71592 2.4207 2.88471C1.66406 3.80667 1.66406 5.17645 1.66406 7.91602C1.66406 10.6556 1.66406 12.0253 2.4207 12.9473C2.5592 13.1161 2.71397 13.2708 2.88275 13.4093C3.75674 14.1267 5.03315 14.1639 7.4974 14.1659"
                                        stroke="black" stroke-opacity="0.5" stroke-width="1.25" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </ng-container>
                            <!-- Copied state -->
                            <ng-template #copiedIcon>
                                <span class="text-green-600 text-sm font-medium">
                                    Copied ✓
                                </span>
                            </ng-template>
                        </span>
                    </div>
                    <!-- <div class="flex justify-center gap-2">
                        <p class="text-base text-secondary-text-black font-medium">{{ mfaResp?.two_factor_recovery_code
                            }}</p>
                        <span class="cursor-pointer" (click)="copyRecoveryCode()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                fill="none">
                                <path
                                    d="M7.5 12.5C7.5 10.143 7.5 8.9645 8.23223 8.23223C8.9645 7.5 10.143 7.5 12.5 7.5H13.3333C15.6903 7.5 16.8688 7.5 17.6011 8.23223C18.3333 8.9645 18.3333 10.143 18.3333 12.5V13.3333C18.3333 15.6903 18.3333 16.8688 17.6011 17.6011C16.8688 18.3333 15.6903 18.3333 13.3333 18.3333H12.5C10.143 18.3333 8.9645 18.3333 8.23223 17.6011C7.5 16.8688 7.5 15.6903 7.5 13.3333V12.5Z"
                                    stroke="black" stroke-opacity="0.5" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M14.164 7.49935C14.162 5.03511 14.1247 3.75869 13.4074 2.88471C13.2689 2.71592 13.1141 2.56117 12.9454 2.42265C12.0234 1.66602 10.6536 1.66602 7.91406 1.66602C5.1745 1.66602 3.80471 1.66602 2.88275 2.42265C2.71397 2.56116 2.55921 2.71592 2.4207 2.88471C1.66406 3.80667 1.66406 5.17645 1.66406 7.91602C1.66406 10.6556 1.66406 12.0253 2.4207 12.9473C2.5592 13.1161 2.71397 13.2708 2.88275 13.4093C3.75674 14.1267 5.03315 14.1639 7.4974 14.1659"
                                    stroke="black" stroke-opacity="0.5" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </span>
                    </div> -->
                </div>

                <button (click)="nextStep()"
                    class="text-sm font-syne bg-black text-white py-3.5 rounded-xl font-semibold hover:text-black hover:bg-secondary-button-black duration-200 ease-in-out cursor-pointer">
                    Next
                </button>
            </div>
        </ng-container>

        <!-- STEP 3 (OTP SCREEN) -->
        <ng-container *ngIf="step === 3">
            <div class="flex flex-col gap-8 text-center">

                <!-- Lock Icon -->
                <div class="mx-auto w-[70px] h-[70px] block">
                    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                        <path d="M42.2602 45.207H42.2865M27.7031 45.207H27.7293" stroke="black" stroke-opacity="0.8"
                            stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M12.453 54.9637C13.1089 59.8354 17.1439 63.6519 22.0542 63.8776C26.186 64.0675 30.3832 64.1667 35.0052 64.1667C39.6273 64.1667 43.8243 64.0675 47.9561 63.8776C52.8666 63.6519 56.9015 59.8354 57.5575 54.9637C57.9856 51.7845 58.3385 48.5263 58.3385 45.2083C58.3385 41.8903 57.9856 38.6321 57.5575 35.453C56.9015 30.5813 52.8666 26.7648 47.9561 26.539C43.8243 26.3491 39.6273 26.25 35.0052 26.25C30.3832 26.25 26.186 26.3491 22.0542 26.539C17.1439 26.7648 13.1089 30.5813 12.453 35.453C12.0249 38.6321 11.6719 41.8903 11.6719 45.2083C11.6719 48.5263 12.0249 51.7845 12.453 54.9637Z"
                            stroke="black" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M21.875 26.2487V18.957C21.875 11.7083 27.7513 5.83203 35 5.83203C42.2488 5.83203 48.125 11.7083 48.125 18.957V26.2487"
                            stroke="black" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>

                <div class="w-full text-left">
                    <h3 class="text-lg md:text-xl lg:text-2xl text-black font-bold mb-2">
                        Enter authenticator code
                    </h3>
                    <p class="text-base font-medium text-secondary-text-black">
                        Please enter the 6-digit code from authenticator app.
                    </p>
                </div>

                <!-- OTP Inputs -->
                <div class="flex justify-center w-full">
                    <ng-otp-input [config]="otpConfig" (onInputChange)="onOtpChange($event)"></ng-otp-input>
                </div>

                <!-- Next -->
                <!-- <button (click)="!isDisableCall ? verifyMFACode() : disableMFA()"
                    class="text-sm font-syne bg-black text-white py-3.5 rounded-xl font-semibold border border-transparent hover:text-black hover:bg-secondary-button-black hover:border-secondary-button-black duration-200 ease-in-out cursor-pointer">
                    {{ !isDisableCall ? 'Next' : 'Disable TFA' }}
                </button> -->

                <p *ngIf="isDisableCall" class="text-black font-semibold text-lg cursor-pointer"
                    (click)="openRecovery()">I lost my recovery
                    code
                </p>

            </div>
        </ng-container>

        <!-- STEP 4 -->
        <ng-container *ngIf="step === 4">
            <div class="flex flex-col gap-6 text-center">

                <!-- Key Icon -->
                <div class="mx-auto w-[70px] h-[70px] block">
                    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                        <path
                            d="M45.2057 42.291C54.8707 42.291 62.7057 34.456 62.7057 24.791C62.7057 15.126 54.8707 7.29102 45.2057 7.29102C35.5408 7.29102 27.7057 15.126 27.7057 24.791C27.7057 27.3589 28.2588 29.7975 29.2524 31.9943L7.28906 53.9577V62.7077H16.0391V56.8744H21.8724V51.041H27.7057L38.0024 40.7443C40.1993 41.738 42.6379 42.291 45.2057 42.291Z"
                            stroke="black" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M51.0417 18.959L48.125 21.8757" stroke="black" stroke-opacity="0.8" stroke-width="3"
                            stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>

                <div class="w-[70%] mx-auto text-center">
                    <h3 class="text-lg md:text-xl lg:text-2xl text-black font-bold mb-2">
                        Save your recovery code
                    </h3>
                    <p class="text-base font-medium text-secondary-text-black">
                        This code can be used to log in if you lose access to your authenticator app.
                        Store it somewhere safe.
                    </p>
                </div>

                <!-- Recovery Code -->
                <div class="w-full flex flex-col items-center gap-2">
                    <div
                        class="w-full flex items-center justify-between gap-2.5 p-3 rounded-lg text-base font-medium bg-secondary-button-black">
                        <span>{{ mfaResp?.two_factor_recovery_code }}</span>
                        <button (click)="copyRecoveryCode(mfaResp?.two_factor_recovery_code)" class="cursor-pointer">
                            <ng-container *ngIf="!isCopied; else copiedIcon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                                    fill="none">
                                    <path
                                        d="M7.5 12.5C7.5 10.143 7.5 8.9645 8.23223 8.23223C8.9645 7.5 10.143 7.5 12.5 7.5H13.3333C15.6903 7.5 16.8688 7.5 17.6011 8.23223C18.3333 8.9645 18.3333 10.143 18.3333 12.5V13.3333C18.3333 15.6903 18.3333 16.8688 17.6011 17.6011C16.8688 18.3333 15.6903 18.3333 13.3333 18.3333H12.5C10.143 18.3333 8.9645 18.3333 8.23223 17.6011C7.5 16.8688 7.5 15.6903 7.5 13.3333V12.5Z"
                                        stroke="black" stroke-opacity="0.5" stroke-width="1.25" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M14.164 7.49935C14.162 5.03511 14.1247 3.75869 13.4074 2.88471C13.2689 2.71592 13.1141 2.56117 12.9454 2.42265C12.0234 1.66602 10.6536 1.66602 7.91406 1.66602C5.1745 1.66602 3.80471 1.66602 2.88275 2.42265C2.71397 2.56116 2.55921 2.71592 2.4207 2.88471C1.66406 3.80667 1.66406 5.17645 1.66406 7.91602C1.66406 10.6556 1.66406 12.0253 2.4207 12.9473C2.5592 13.1161 2.71397 13.2708 2.88275 13.4093C3.75674 14.1267 5.03315 14.1639 7.4974 14.1659"
                                        stroke="black" stroke-opacity="0.5" stroke-width="1.25" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </ng-container>
                            <!-- Copied state -->
                            <ng-template #copiedIcon>
                                <span class="text-green-600 text-sm font-medium">
                                    Copied ✓
                                </span>
                            </ng-template>
                        </button>
                    </div>

                    <p class="text-base text-secondary-text-black font-medium">
                        Your recovery code
                    </p>
                </div>
                <button
                    class="text-sm font-syne bg-black text-white py-3.5 rounded-xl font-semibold border border-transparent hover:text-black hover:bg-secondary-button-black hover:border-secondary-button-black duration-200 ease-in-out cursor-pointer"
                    (click)="nextStep()">
                    Finish set up
                </button>
            </div>
        </ng-container>

        <!-- STEP 5 -->
        <ng-container *ngIf="step === 5">
            <div class="flex flex-col gap-6 text-center">
                <div
                    class="flex items-center justify-center w-[70px] h-[70px] mx-auto rounded-full bg-primary-text-green">
                    <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                        <path
                            d="M8.75 25.375C8.75 25.375 11.375 25.375 14.875 31.5C14.875 31.5 24.6029 15.4583 33.25 12.25"
                            stroke="white" stroke-width="2.625" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>
                <div class="text-center">
                    <h3 class="text-lg md:text-xl lg:text-2xl text-black font-bold mb-2">
                        Two-factor authentication {{ isDisableCall ? 'Disabled' : 'enabled' }}
                    </h3>
                    <p class="text-base font-medium text-secondary-text-black">
                        {{ isDisableCall ? 'Your account is no longer protected with 2FA.' : 'Your account is now protected with 2FA. Make sure to save your recovery codes.' }}
                    </p>
                </div>
            </div>
        </ng-container>

        <!-- STEP 6 (RECOVERY CODE SCREEN) -->
        <ng-container *ngIf="step === 6">
            <!-- Back Button for Recovery -->
            <button
                class="flex items-center justify-center absolute left-6 top-6 w-[37px] h-[37px] text-secondary-text-black bg-light-black-100 rounded-full hover:text-white hover:bg-black duration-200 ease-in-out cursor-pointer"
                (click)="closeRecovery()">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                    <path d="M3.46875 9.50146H16.0015" stroke="currentColor" stroke-opacity="0.8" stroke-width="1.4"
                        stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M8.57006 15.0714C8.57006 15.0714 3.00001 10.969 3 9.50123C2.99999 8.03341 8.57015 3.93115 8.57015 3.93115"
                        stroke="currentColor" stroke-opacity="0.8" stroke-width="1.4" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>

            <div class="flex flex-col gap-8 text-center pt-8">

                <div class="mx-auto w-[70px] h-[70px] block">
                    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70" fill="none">
                        <path d="M42.2602 45.207H42.2865M27.7031 45.207H27.7293" stroke="black" stroke-opacity="0.8"
                            stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
                        <path
                            d="M12.453 54.9637C13.1089 59.8354 17.1439 63.6519 22.0542 63.8776C26.186 64.0675 30.3832 64.1667 35.0052 64.1667C39.6273 64.1667 43.8243 64.0675 47.9561 63.8776C52.8666 63.6519 56.9015 59.8354 57.5575 54.9637C57.9856 51.7845 58.3385 48.5263 58.3385 45.2083C58.3385 41.8903 57.9856 38.6321 57.5575 35.453C56.9015 30.5813 52.8666 26.7648 47.9561 26.539C43.8243 26.3491 39.6273 26.25 35.0052 26.25C30.3832 26.25 26.186 26.3491 22.0542 26.539C17.1439 26.7648 13.1089 30.5813 12.453 35.453C12.0249 38.6321 11.6719 41.8903 11.6719 45.2083C11.6719 48.5263 12.0249 51.7845 12.453 54.9637Z"
                            stroke="black" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M21.875 26.2487V18.957C21.875 11.7083 27.7513 5.83203 35 5.83203C42.2488 5.83203 48.125 11.7083 48.125 18.957V26.2487"
                            stroke="black" stroke-opacity="0.8" stroke-width="3" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>

                <div class="w-full text-left">
                    <h3 class="text-lg md:text-xl lg:text-2xl text-black font-bold mb-2">
                        Enter Recovery code
                    </h3>
                    <p class="text-base font-medium text-secondary-text-black">
                        To disable 2FA, enter your recovery code.
                    </p>
                </div>
                <div class="flex justify-center w-full">
                    <ng-otp-input [config]="recoveryOtpConfig" (onInputChange)="onOtpChange($event)"></ng-otp-input>
                </div>

                <!-- <div class="flex flex-col gap-5">
                    <button (click)="disableWithRecovery()"
                        class="flex items-center justify-center gap-2.5 text-base font-syne bg-secondary-button-black text-secondary-text-black px-5 rounded-xl font-semibold hover:text-white hover:bg-black  duration-200 ease-in-out cursor-pointer">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                                stroke="black" stroke-opacity="0.8" stroke-width="1.5" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M12 16V11.5" stroke="currentColor" stroke-opacity="0.8" stroke-width="1.5"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 8.01195V8.00195" stroke="currentColor" stroke-opacity="0.8" stroke-width="1.8"
                                stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        Disable 2FA with Recovery Code
                    </button>

                </div> -->
            </div>
        </ng-container>

    </div>
</div>